// These are utility data-ignore-target attributes to control approval drawer opening and closing when actionable items are clicked in the status popup

// Should prevent default to prevent the whole approver not to be clicked

export const STATUS_DECLINED_BUTTON_CLICK_IGNORE_TARGET =
	'software-releases-approvers.ui.task-approver.approval-status.declined-button';
export const STATUS_PENDING_BUTTON_CLICK_IGNORE_TARGET =
	'software-releases-approvers.ui.task-approver.approval-status.pending-button';
export const STATUS_APPROVED_BUTTON_CLICK_IGNORE_TARGET =
	'software-releases-approvers.ui.task-approver.approval-status.approved-button';
export const STATUS_POPUP_TRIGGER_CLICK_IGNORE_TARGET =
	'software-releases-approvers.ui.task-approver.approval-status.status-popup-trigger';

export const getIgnoreMouseEventTargetSelector = () =>
	`[data-ignore-target="${STATUS_DECLINED_BUTTON_CLICK_IGNORE_TARGET}"], 
[data-ignore-target="${STATUS_PENDING_BUTTON_CLICK_IGNORE_TARGET}"],
[data-ignore-target="${STATUS_APPROVED_BUTTON_CLICK_IGNORE_TARGET}"],
[data-ignore-target="${STATUS_POPUP_TRIGGER_CLICK_IGNORE_TARGET}"]`;

export const getDeclineButtonSelector = () =>
	`[data-ignore-target="${STATUS_DECLINED_BUTTON_CLICK_IGNORE_TARGET}"]`;
